import React, { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Grid,
  Dialog,
  DialogTitle,
  Button,
  makeStyles,
  DialogContent,
  Typography,
  DialogActions,
  CircularProgress,
  Chip,
  Paper,
} from "@material-ui/core";
import { Delete, Refresh, Print, HistoryOutlined } from "@material-ui/icons";
import { useReactToPrint } from "react-to-print";
import { useSelector, shallowEqual } from "react-redux";
import { useSnackbar } from "notistack";
import jMoment from "moment-jalaali";
import { selectUser } from "../../features/data/user/userSlice";
import { useFetch } from "../../features/customHooks/useFetch";
import ValuationHistory from "../../components/valuationHistory/ValuationHistory";
import PrintPage from "../printPage/PrintPage";
import ClientInfo from "./clientInfo/ClientInfo";
import BaseInfo from "./baseInfo/BaseInfo";
import Sketch from "./sketch/Sketch";
import Credits from "./credits/Credits";
import Parts from "./parts/Parts";
import SupplementaryInfo from "./supplementaryInfo/SupplementaryInfo";
import MapView from "./mapView/MapView";

jMoment.loadPersian({ dialect: "persian-modern", usePersianDigits: false });

const useStyles = makeStyles((theme) => ({}));

const ValuationViewer = (props) => {
  const classes = useStyles();
  const { user } = useSelector(selectUser, shallowEqual);

  const { enqueueSnackbar } = useSnackbar();

  const [croquisType, setCroquisType] = useState("map");
  const timerRef = useRef(null);
  const [count, setCount] = useState(null);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const handleDeleteDialogOpen = () => setDeleteDialogOpen(true);
  const handleDeleteDialogClose = () => setDeleteDialogOpen(false);

  const [revaluateDialogOpen, setRevaluateDialogOpen] = useState(false);
  const handleRevaluateDialogOpen = () => setRevaluateDialogOpen(true);
  const handleRevaluateDialogClose = () => setRevaluateDialogOpen(false);

  const [historyDialogOpen, setHistoryDialogOpen] = useState(false);
  const handleHistoryDialogOpen = () => setHistoryDialogOpen(true);
  const handleHistoryDialogClose = () => setHistoryDialogOpen(false);

  const printRef = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  const navigate = useNavigate();
  const params = useParams();

  const initialParams = {
    method: "get",
    url: "/valuation/" + params.id,
  };
  const initialPartsParams = {
    method: "get",
    url: "/valuation/part/" + params.id,
  };
  const initialCreditsParams = {
    method: "get",
    url: "/valuation/credit/" + params.id,
  };
  const [getFetchState, setGetFetchParams] = useFetch(initialParams);
  const [getPartsFetchState, setGetPartsFetchParams] = useFetch(initialPartsParams);
  const [getCreditsFetchState, setGetCreditsFetchParams] = useFetch(initialCreditsParams);
  const [getSketchFetchState, setGetSketchFetchParams] = useFetch();
  const [deleteFetchState, setDeleteFetchParams] = useFetch();
  const [revaluateFetchState, setRevaluateFetchParams] = useFetch();

  const regetValuation = () => setGetFetchParams(initialParams);
  const regetParts = () => setGetPartsFetchParams(initialPartsParams);
  const regetCredits = () => setGetCreditsFetchParams(initialCreditsParams);
  const regetSketch = (fileName) => {
    const params = {
      method: "post",
      url: "/get_sketch",
      data: {
        filename: fileName,
      },
    };
    setGetSketchFetchParams(params);
  };

  const revaluateValuation = () => {
    const fetchParams = {
      method: "post",
      url: "/valuation/revaluate/" + params.id,
    };
    setRevaluateFetchParams(fetchParams);
  };

  const deleteValuation = () => {
    const fetchParams = {
      method: "delete",
      url: "/valuation/" + params.id,
    };
    setDeleteFetchParams(fetchParams);
  };

  useEffect(() => {
    if (params.id) {
      regetValuation();
      regetParts();
      regetCredits();
    }
  }, [params.id]);

  useEffect(() => {
    if (!revaluateFetchState.loading && !revaluateFetchState.error && revaluateFetchState.data) {
      navigate(`../valuations/view/${revaluateFetchState?.data?.data?.id}`);
      handleRevaluateDialogClose();
      enqueueSnackbar("ارزیابی ایجاد شد و به ارزیابی جدید منتقل شدید برای ویرایش اقدام کنید", {
        variant: "success",
      });
    }
  }, [revaluateFetchState]);

  useEffect(() => {
    if (!deleteFetchState.loading && !deleteFetchState.error && deleteFetchState.data) navigate("/panel/valuations");
  }, [deleteFetchState]);

  useEffect(() => {
    if (!getFetchState.loading && !getFetchState.error && getFetchState.data) {
      regetSketch(getFetchState?.data?.data?.sketch_url);
      setCount(0);
    }

    return () => {
      clearInterval(timerRef.current);
    };
  }, [getFetchState]);

  useEffect(() => {
    if (count <= 4 && count !== null) {
      timerRef.current = setTimeout(() => {
        setCount((prevState) => prevState + 1);
      }, 1000);
    }
    return () => {
      clearTimeout(timerRef.current);
    };
  }, [count]);

  return (
    <Fragment>
      <Grid direction='row' container style={{ padding: 10 }}>
        <Grid container alignItems='center' justifyContent='center' style={{ marginBottom: 10 }}>
          {/* <Tooltip title='بازگشت'>
            <Link to={-1}>
              <IconButton>
                <ArrowForwardOutlined />
              </IconButton>
            </Link>
          </Tooltip> */}
          <Typography
            style={{
              // marginRight: 10,
              fontSize: 30,
              fontWeight: 800,
            }}
          >
            اطلاعات ارزیابی
          </Typography>

          <div style={{ flexGrow: 1 }} />
          {/* <Typography
            style={{
              // marginRight: 10,
              fontSize: 12,
              fontWeight: 500,
              marginRight: 10,
            }}
          >
            چاپ کروکی:
          </Typography> */}

          {(getFetchState?.data?.data?.user?.id === user?.id || user.role === "admin") && !getFetchState?.loading && (
            <Fragment>
              <Button
                variant='contained'
                color='primary'
                endIcon={<HistoryOutlined />}
                onClick={handleHistoryDialogOpen}
              >
                تاریخچه ارزیابی
              </Button>
              <Button
                variant='contained'
                color='primary'
                endIcon={<Refresh />}
                style={{ marginRight: 10 }}
                onClick={handleRevaluateDialogOpen}
              >
                ارزیابی مجدد
              </Button>
              <Button
                variant='outlined'
                color='primary'
                endIcon={<Delete />}
                style={{ marginRight: 10 }}
                onClick={handleDeleteDialogOpen}
              >
                حذف
              </Button>

              <Paper
                style={{
                  marginRight: 10,
                  // padding: 5,
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                {count <= 4 && (
                  <div
                    style={{
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      backgroundColor: "#ffffff66",
                      zIndex: 3,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CircularProgress size={20} />
                  </div>
                )}
                <Grid container style={{ padding: 5 }} alignItems='center' justifyContent='center'>
                  <Button variant='contained' color='primary' size='small' endIcon={<Print />} onClick={handlePrint}>
                    چاپ
                  </Button>
                  <Chip
                    color={croquisType === "map" ? "primary" : "secondary"}
                    variant={croquisType === "map" ? "default" : "outlined"}
                    label='نقشه'
                    size='small'
                    onClick={() => {
                      setCroquisType("map");
                      setCount(0);
                    }}
                    style={{ marginRight: 10 }}
                  />

                  <Chip
                    color={croquisType === "sketch" ? "primary" : "secondary"}
                    variant={croquisType === "sketch" ? "default" : "outlined"}
                    label='رسم'
                    size='small'
                    onClick={() => {
                      setCroquisType("sketch");
                      setCount(0);
                    }}
                    style={{ marginRight: 10, marginLeft: 10 }}
                  />
                </Grid>
              </Paper>
            </Fragment>
          )}
        </Grid>

        <div style={{ height: "0px", overflow: "hidden" }}>
          {/* <PrintView
              ref={printRef}
              data={{
                valuation: getFetchState?.data?.data,
                parts: getPartsFetchState?.data?.data,
                credits: getCreditsFetchState?.data?.data,
                sketch: getSketchFetchState?.data,
                sketchType: croquisType,
                loading:
                  getFetchState?.loading ||
                  getSketchFetchState?.loading ||
                  getCreditsFetchState.loading ||
                  getPartsFetchState.loading,
              }}
            /> */}
          <PrintPage
            ref={printRef}
            // ref={(el) => (this.componentRef = el)}
            sketch={getSketchFetchState?.data}
            sketchType={croquisType}
            valuation={getFetchState?.data?.data}
            parts={getPartsFetchState?.data?.data}
            credits={getCreditsFetchState?.data?.data}
            // secret={this.state.secret}
          />
        </div>

        <Grid item xs={12}>
          <ClientInfo
            data={{
              loading: getFetchState?.loading,
              valuation: getFetchState?.data?.data,
              regetValuation,
            }}
          />
        </Grid>

        <Grid item xs={12} style={{ paddingTop: 10 }}>
          <BaseInfo
            data={{
              loading: getFetchState?.loading,
              valuation: getFetchState?.data?.data,
              regetValuation,
            }}
          />
        </Grid>

        <Grid item xs={12} style={{ paddingTop: 10 }}>
          <Parts
            data={{
              valuationId: getFetchState?.data?.data?.id,
              canEdit: getFetchState?.data?.data?.can_edit,
              parts: getPartsFetchState?.data?.data,
              loading: getPartsFetchState?.loading,
              reget: regetParts,
            }}
          />
        </Grid>

        <Grid item xs={12} style={{ paddingTop: 10 }}>
          <Credits
            data={{
              valuationId: getFetchState?.data?.data?.id,
              canEdit: getFetchState?.data?.data?.can_edit,
              credits: getCreditsFetchState?.data?.data,
              loading: getCreditsFetchState?.loading,
              reget: regetCredits,
            }}
          />
        </Grid>

        <Grid item xs={12} style={{ paddingTop: 10 }}>
          <SupplementaryInfo
            data={{
              valuation: getFetchState?.data?.data,
              loading: getFetchState?.loading,
              regetValuation,
            }}
          />
        </Grid>

        <Grid item style={{ paddingTop: 10, flexGrow: 1 }}>
          <MapView
            data={{
              loading: getFetchState?.loading,
              valuation: getFetchState?.data?.data,
              regetValuation,
            }}
          />
        </Grid>

        <Grid item style={{ paddingTop: 10, marginRight: 10 }}>
          <Sketch
            data={{
              sketch: getSketchFetchState?.error ? null : getSketchFetchState?.data,
              loading: getFetchState?.loading || getSketchFetchState?.loading,
              canEdit: getFetchState?.data?.data?.can_edit,
              valuationId: getFetchState?.data?.data?.id,
              valuation: getFetchState?.data?.data,
              reget: regetValuation,
            }}
          />
        </Grid>
      </Grid>
      {(getFetchState?.data?.data?.user?.id === user?.id || user.role === "admin") && !getFetchState?.loading && (
        <Fragment>
          <Dialog open={historyDialogOpen} onClose={handleHistoryDialogClose} maxWidth='md' fullWidth>
            <DialogTitle>تاریخچه ارزیابی</DialogTitle>
            <DialogContent>
              <ValuationHistory postalCode={getFetchState?.data?.data?.postal_code} />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleHistoryDialogClose}>بستن</Button>
            </DialogActions>
          </Dialog>
          <Dialog open={deleteDialogOpen} onClose={handleDeleteDialogClose}>
            <DialogTitle>حذف ارزیابی</DialogTitle>
            <DialogContent>
              <Typography>آیا از حذف ارزیابی با شناسه {getFetchState?.data?.data?.full_id} اطمینان دارید؟</Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleDeleteDialogClose} disabled={deleteFetchState.loading}>
                لغو
              </Button>
              <Button
                onClick={deleteValuation}
                variant='contained'
                color='secondary'
                disabled={deleteFetchState.loading}
              >
                {deleteFetchState.loading ? <CircularProgress size={20} /> : "حذف ارزیابی"}
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog open={revaluateDialogOpen} onClose={handleRevaluateDialogClose} maxWidth='xs'>
            <DialogTitle>ارزیابی مجدد</DialogTitle>
            <DialogContent>
              <Typography>
                با ادامه، ارزیابی جدید با همین مشخصات ساخته میشود، آیا از ایجاد یک ارزیابی جدید اطمینان دارید؟
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleRevaluateDialogClose} disabled={revaluateFetchState.loading}>
                لغو
              </Button>
              <Button
                onClick={revaluateValuation}
                variant='contained'
                color='secondary'
                disabled={deleteFetchState.loading}
              >
                {revaluateFetchState.loading ? <CircularProgress size={20} /> : "ارزیابی مجدد"}
              </Button>
            </DialogActions>
          </Dialog>
        </Fragment>
      )}
    </Fragment>
  );
};

export default ValuationViewer;
